/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CheckedRuleDto } from './CheckedRuleDto';

export type LoadMonitorRecommendationGenerationJobResultsResponseDto = {
    checkedRules: Array<CheckedRuleDto>;
    jobStatus: LoadMonitorRecommendationGenerationJobResultsResponseDto.jobStatus;
};

export namespace LoadMonitorRecommendationGenerationJobResultsResponseDto {

    export enum jobStatus {
        PENDING = 'PENDING',
        RUNNING = 'RUNNING',
        SUCCESS = 'SUCCESS',
        ERROR = 'ERROR',
    }


}
